import getHoursInRange from '@/logic/helpers/dates/getHoursInRange';
import { takenSlot } from './helpToApplyTakenSlots';
import getFullHour from '@/logic/helpers/dates/getFullHour';
import setFullDate from '@/logic/helpers/dates/setFullDate';

interface argsType {
  hour: {
    time: any;
    alreadyBooked: boolean;
    candidate:
      | {
          first_name: string;
          id: string;
          profile_image: string;
          surname: string;
        }
      | string;
    takeAction: boolean;
  };
  takenSlots: takenSlot[];
  date: string;
  assessmentLength: number;
  differentCand: boolean;
  differentCandOnPlusALSlot: boolean;
  candId: string;
}

interface unavailableHour {
  hour: string;
  cand:
    | {
        first_name: string;
        id: string;
        profile_image: string;
        surname: string;
      }
    | string;
  meetingStatus: string;
}

const oneHourInMs = 3_600_000;
const halfAnHourInMs: number = oneHourInMs / 2;

//* AL - Assessment Length
export const assessmentLengthBlocksSlot = (args: argsType): boolean => {
  if (!args.takenSlots?.length) return;

  const unavailableHours: unavailableHour[] = getUnavailableHours(args.takenSlots);
  const unavailableHoursFlat: string[] = unavailableHours.flatMap((obj) => obj.hour);
  const slotHourFullDate: Date = new Date(setFullDate(args.date, args.hour.time));
  const slotHourFullDatePlusAL: Date = new Date(
    calculateSlotFullDatePlusAL(slotHourFullDate, args.assessmentLength),
  );

  const foundSlotBookedForOtherCandInBetween: boolean = checkIfThereAreBookedSlotsInBetween({
    slotDate: slotHourFullDate,
    slotDatePlusAL: slotHourFullDatePlusAL,
    unavailableHours,
    unavailableHoursFlat,
    candId: args.candId,
  });

  return (
    foundSlotBookedForOtherCandInBetween ||
    (unavailableHoursFlat.includes(getFullHour(slotHourFullDate)) && args.differentCand) ||
    (unavailableHoursFlat.includes(getFullHour(slotHourFullDatePlusAL)) &&
      args.differentCandOnPlusALSlot &&
      !unavailableHours
        .find((hour) => hour.hour === getFullHour(slotHourFullDatePlusAL))
        ?.meetingStatus.includes('proposed'))
  );
};

const getUnavailableHours = (takenSlots: takenSlot[]): unavailableHour[] => {
  const unavailableHours: unavailableHour[] = takenSlots.flatMap((takenSlot) => {
    return getHoursInRange(
      getFullHour(takenSlot.assessment_dates[0].date_start),
      getFullHour(takenSlot.assessment_dates[takenSlot.assessment_dates.length - 1].date_end),
    ).map((hour) => ({
      hour: hour,
      cand: takenSlot.candidate,
      meetingStatus: takenSlot.assessment_dates[0].status,
    }));
  });

  return unavailableHours;
};

export const calculateSlotFullDatePlusAL = (
  slotHourFullDate: Date,
  assessmentLength: number,
): number => {
  return slotHourFullDate.getTime() + assessmentLength * oneHourInMs - halfAnHourInMs;
};

interface checkIfThereAreBookedSlotsInBetweenInterface {
  slotDate: Date;
  slotDatePlusAL: Date;
  unavailableHours: unavailableHour[];
  unavailableHoursFlat: string[];
  candId: string;
}

const checkIfThereAreBookedSlotsInBetween = (
  args: checkIfThereAreBookedSlotsInBetweenInterface,
): boolean => {
  const slotDateInMs: number = args.slotDate.getTime();
  let slotDatePlusALInMs: number = args.slotDatePlusAL.getTime();
  let bookedSlotFoundInBetween: boolean;

  while (slotDatePlusALInMs > slotDateInMs && !bookedSlotFoundInBetween) {
    let assignedCand = getHourPlusALObj(args.unavailableHours, slotDatePlusALInMs)?.cand;

    if (typeof assignedCand === 'string') {
      assignedCand = {
        first_name: '',
        id: '',
        profile_image: '',
        surname: '',
      };
    }

    bookedSlotFoundInBetween =
      !getHourPlusALObj(args.unavailableHours, slotDatePlusALInMs)?.meetingStatus.includes(
        'proposed',
      ) &&
      args.unavailableHoursFlat.includes(getFullHour(new Date(slotDatePlusALInMs))) &&
      assignedCand?.id !== args.candId;

    slotDatePlusALInMs -= halfAnHourInMs;
  }

  return bookedSlotFoundInBetween;
};

const getHourPlusALObj = (
  unavailableHours: unavailableHour[],
  slotDatePlusALInMs: number,
): unavailableHour | undefined => {
  return unavailableHours.find((hour) => {
    return hour.hour === getFullHour(new Date(slotDatePlusALInMs));
  });
};
